export class HtmlEscaper {

    /**
     * Escapes html in a string
     */
    public static escapeHtml(unsafeString: string): string {
        // Strings are unreliably escaped, so we unescape the results, then re-escape them
        return unsafeString
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#039;/g, "'")
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    // Removes all html tags from the html string.
    public static stripTags(html: string): string {
        if (!html) {
            return '';
        }

        return html.replace(/<.*?>/g, '');
    }
}
